import React, { createContext, useState, useEffect } from 'react';
import { addDays } from 'date-fns';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Import Spanish locale for dayjs
import Cookies from 'js-cookie';
import {obtenerDatosHotel} from '../../services/motorService';
const RoomTypeRatePlanContext = createContext();


export const AppProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [reservaAdmintour, setReservaAdmintour] = useState(null);
  const hotCod = Cookies.get('hotCod');
  useEffect(() => {
    console.log('Cart items updated:', cartItems);
  }, [cartItems, reservaAdmintour]);

  const [selectedDetails, setSelectedDetails] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 2),
    roomType: '',
    ratePlan: '',
  });

  useEffect(() => {
    const fetchMinimumNights = async () => {
      try {
        const hotelData = await obtenerDatosHotel(hotCod);
        const minNights = hotelData.motorhotminimonoches || 1; 
        const newEndDate = addDays(new Date(), minNights);

        setSelectedDetails((prev) => ({
          ...prev,
          startDate: new Date(),
          endDate: newEndDate,
        }));
      } catch (error) {
        console.error('Error fetching minimum nights:', error);
      }
    };

    fetchMinimumNights();
  }, [hotCod]);

  useEffect(() => {
    console.log('Selected details updated:', selectedDetails);
  }, [selectedDetails]);

  return (
    <RoomTypeRatePlanContext.Provider value={{ selectedDetails, setSelectedDetails, cartItems, setCartItems, reservaAdmintour, setReservaAdmintour }}>
      {children}
    </RoomTypeRatePlanContext.Provider>
  );
};

export default RoomTypeRatePlanContext;